import React, { useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../components/LoaderScreen";
import { GetKey } from "../../Finanzas/Actions/GetContainer";
import { useBox } from "../../Finanzas/Helper/useBox";
import Swal from "sweetalert2";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import request from "../../../Helpers/API";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { capitalizePalabras } from "../../../Helpers/CapitalizePalabras";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import EditIcon from '@mui/icons-material/Edit';
import FiltroCobranza from "./FiltroCobranza";
import FiltroSucursales from "./FiltroSucursales";

export const NotasDescuentoScreen = () => {
    const history = useHistory();
    const location = useLocation();
    const [boxstate, setBoxState] = useBox();
    const [notasDescuento, setNotasDescuento] = useState();
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
      useEffect(() => {
        onExecute()
      }, []);

    const onExecute = (
        // ejercicio_inicio,
        // ejercicio_fin,
        // periodo_inicio,
        // periodo_fin
    ) => {
        setLoader({ ...loader, mostrar: true });
        var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
        var adr = GetKey(boxstate.pv.adr, ["idadr"]);
        var p_fin = "";
        if (sucursales === undefined || sucursales === null || sucursales === "") {
            sucursales = "0";
        }
        if (adr === undefined || adr === null || adr === "") {
            adr = "0";
        }

        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `NotasDescuento/ObtenerNotas?adr=${adr}&sucursal=${sucursales}`
                )
                .then((result) => {

                    setLoader({ ...loader, mostrar: false });
                    setNotasDescuento(result);
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    reject(error);
                    return;
                });
        });
    };

    const onRegresar = () => {
        history.push("/Creditoycobranza/Main");
    };

    return (
        <PlantillaScreen
            titulo={"NOTAS DE DESCUENTOS"}
            className={"notas-descuento-main-screen"}
            className_main={2}
        >
            <LoaderScreen loader={loader} />
            <div className="notas-descuento-actions">
                <div
                    className="notas-descuento-actions-regresar"
                    onClick={() => onRegresar()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <div className="notas-descuento-actions-filtro">
                    <FiltroSucursales
                        onExecute={onExecute}
                        boxState={boxstate}
                        onBoxChange={setBoxState}
                    />
                </div>
            </div>
            <div className="contador-notas-descuento-encontrados">
                Notas encontradas: {notasDescuento?.length}
            </div>
            {notasDescuento && notasDescuento.length > 0 && (
                <div className="notas-descuento">
                    <div className="notas-descuento-container scroll">
                        <table cellPadding={0} cellSpacing={0}>
                            <thead>
                                <tr>
                                    <th>Sucursal</th>
                                    <th>
                                        <div>ID EQUIP</div>
                                    </th>
                                    <th>
                                        <div>Cliente</div>
                                    </th>
                                    <th>
                                        <div>Documento</div>
                                    </th>
                                    <th>
                                        <div>Serie</div>
                                    </th>
                                    <th>
                                        <div>Folio</div>
                                    </th>
                                    <th>
                                        <div>Fecha</div>
                                    </th>
                                    <th>
                                        <div>Vencimiento</div>
                                    </th>
                                    <th>
                                        <div>Importe factura</div>
                                    </th>
                                    <th>
                                        <div>Importe pagado</div>
                                    </th>
                                    <th>
                                        <div>Saldo pendiente</div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {notasDescuento.map((item, index) => (
                                    <tr key={index}>
                                        <td>{capitalizePalabras(item.sucursal)}</td>
                                        <td className="ta-center">{item.idcliente}</td>
                                        <td>{capitalizePalabras(item.razonsocial)}</td>
                                        <td className="ta-center">{item.documento}</td>
                                        <td className="ta-center">{item.serie}</td>
                                        <td className="ta-center">{item.folio}</td>
                                        <td className="ta-center">{item.fecha}</td>
                                        <td className="ta-center">{item.vencimiento}</td>
                                        <td className="ta-right">{FormatMoney(item.importefactura, 2)}</td>
                                        <td className="ta-right">{FormatMoney(item.importepagado, 2)}</td>
                                        <td className="ta-right">{FormatMoney(item.saldo_pendiente, 2)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </PlantillaScreen>
    );
};
